module.exports = __webpack_public_path__ + "static/media/LogoMorbelliHori.843b4de0.png";